import {Component, Input} from '@angular/core';

@Component({
    selector: 'mm-text-overflow-ellipsis',
    templateUrl: './text-overflow-ellipsis.component.html',
    styleUrls: ['./text-overflow-ellipsis.component.scss'],
    standalone: false
})
export class TextOverflowEllipsisComponent {
    @Input({required: true})
    public text!: string;
}
